
export const transformContributor = (contributor) => {
  switch (contributor.discriminator) {
    case "person":
      return contributor.person && contributor.person.name;
    case "organization":
      return contributor.organization ? contributor.organization.name : "";
    default:
      return "Unknown contributor type";
  }
};

export const transformConcept = (concept) => {
  return concept.name;
};


export const flattenContributors = (
  contributors,
  options = {}
) => {
  const new_contributors = {...contributors};
  Object.keys(new_contributors).forEach(type => {
    new_contributors[type].forEach((contributor, index) => {
      contributor.name = transformContributor(contributor);
      if(options.onlyNames) new_contributors[type][index] = contributor.name;
    });
  });
  return new_contributors;
};

export const flattenConcepts = (conceptPaths, options = {}) => {
  const newConcepts = {};
  for( const code in conceptPaths) {
    const concepts = conceptPaths[code].concepts;
    newConcepts[code] = options.onlyNames === true ? concepts.map(transformConcept) : [...concepts];
  }
  return newConcepts;
};

export const getImageURL = (image) => image?.formats?.small?.url || image?.formats?.thumbnail?.url || image?.url;

export const formatImage = (image, format) => {
  if (!image || typeof image !== "object") return null;

  if (image.formats && format) {
    if (format === "thumbnail")
      return (image.formats["thumbnail"] || image.formats["small"] || image.formats["medium"] || image.formats["large"] || image).url;
    if (format === "small")
      return (image.formats["small"] || image.formats["medium"] || image.formats["large"] || image).url;
    if (format === "medium")
      return (image.formats["medium"] || image.formats["large"] || image).url;
    if (format === "large")
      return (image.formats["large"] || image).url;
  }

  return image.url;
};

export const formatResourceName = (resource, shortForm = false) => {
  let name = `${resource.name}${resource.meta.subtitle ? `: ${resource.meta.subtitle}` : ""}`;

  if (shortForm !== true) {
    name += `${resource.meta.edition ? ` - ${resource.meta.edition}` : ""}${resource.meta.publisher ? ` (${resource.meta.publisher})` : ""}`;
  }

  return name;
};
